import { Waypoint } from 'react-waypoint'
import classnames from 'classnames'

import { ArticleCard } from '../article-card'

import styles from './styles.module.scss'

export type GuidesType = {
  picture: string
  categoryName?: string
  title: string
  resume: string
  readingTime: number
  href: string
  id: string
}

type ArticleListProps = {
  posts: GuidesType[]
  onLoadMore?: () => void
  hideThirdCard?: boolean
  hideCategoryTag?: boolean
  className?: string
}

export const ArticleList = ({
  posts,
  onLoadMore,
  className,
  hideThirdCard = false,
  hideCategoryTag = false,
}: ArticleListProps) => {
  return (
    <ul className={classnames(styles['article-list'], className)}>
      {posts.map((post, index) => (
        <li
          key={`post-${post.title}`}
          className={classnames({ [styles['card-item']]: hideThirdCard })}
        >
          {index === posts.length - 1 && <Waypoint onEnter={onLoadMore} />}
          <ArticleCard
            tag={hideCategoryTag ? null : post.categoryName}
            href={post.href}
            title={post.title}
            description={post.resume}
            picture={post.picture}
            minutesRead={post.readingTime}
          />
        </li>
      ))}
    </ul>
  )
}
